/**
 * Horror Race token helpers — cycling per-seat token reference for an
 * arbitrary player index. Seats 0–5 map to --cn-horror-seat-1..6 (T3:
 * disjoint from the 5 character hues). Seats 6–11 fall back to the
 * luminance-shifted p7..p12 slots. Index wraps with modulo so a future
 * >12-player config still gets a token rather than throwing.
 */

const HORROR_SEAT_COUNT = 6;
const HORROR_PAWN_COUNT = 12;

export function getHorrorPlayerToken(idx: number): string {
  // WHY modulo: brief caps players at 12; wrap defensively.
  const wrapped =
    ((idx % HORROR_PAWN_COUNT) + HORROR_PAWN_COUNT) % HORROR_PAWN_COUNT;
  // Seats 0–5: dedicated seat ramp (visually distinct from character hues).
  // Seats 6–11: luminance-shifted legacy p7..p12.
  if (wrapped < HORROR_SEAT_COUNT) {
    return `var(--cn-horror-seat-${wrapped + 1})`;
  }
  return `var(--cn-horror-p${wrapped + 1})`;
}
